'use client';

import { Box } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { shallowEqual, useSelector } from 'react-redux';
import { useActiveBrand } from '@/_hooks/useActiveBrand';
import { IRedux } from '@/_store/types';
import type { IProduct } from '@/entities/product/model/types';
import { isProductInStock } from '../_lib/is-product-in-stock';

export default function Availability({ data }: { data?: IProduct }) {
  const t = useTranslations();
  const shipperId = useActiveBrand();
  const { branches } = useSelector(
    (state: IRedux) => ({ branches: state.common.branches }),
    shallowEqual,
  );
  const branch = shipperId ? branches?.[shipperId] : undefined;
  const inStock = isProductInStock(data, branch?.menu_id);

  return (
    <Box
      px={2}
      py={1}
      borderRadius='lg'
      bg={inStock ? 'green.300' : 'red.500'}
      color={inStock ? 'green.700' : '#fff'}
      fontWeight={600}
      fontSize='xs'
      w='fit-content'
    >
      {inStock ? t('in_stock') : t('out_of_stock')}
    </Box>
  );
}
